import ScheduleDetailPanel from './ScheduleDetailPanel';

export default ScheduleDetailPanel;
